// src/components/union-settings/banks/UnionDeleteBankDialog.tsx
import { Button, Dialog, Portal } from '@chakra-ui/react'
import { useState } from 'react'
import { deleteBank } from '@/api/settings.api'
import { toast } from '@/components/ui/toaster/toasterHelpers'

export default function UnionDeleteBankDialog({
  open,
  onOpenChange,
  bankId,
  onDeleted,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  bankId: number
  onDeleted: () => void | Promise<void>
}) {
  const [loading, setLoading] = useState(false)

  const handleDelete = async () => {
    setLoading(true)
    try {
      await deleteBank(bankId)
      await onDeleted()
      onOpenChange(false)
    } catch (e: any) {
      // Backend may return domain error codes later; keep generic + allow mapping
      if (e?.code === 'RECORD_IN_USE') {
        toast.error('Bank kann nicht gelöscht werden', 'Der Datensatz wird derzeit verwendet.')
      } else {
        toast.error(
          'Bank konnte nicht gelöscht werden',
          'Bitte führen Sie den Vorgang erneut aus.'
        )
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog.Root open={open} onOpenChange={e => onOpenChange(e.open)} size="xs">
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content rounded="l3" shadow="0px 8px 16px 0px gray.900;">
            <Dialog.Header>
              <Dialog.Title fontSize="lg" fontWeight="600">
                Bank löschen
              </Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>

            <Dialog.Body color="fg.muted" fontSize="sm" mt={-3}>
              Die Bank kann innerhalb von 100 Tagen wiederhergestellt werden. Nach Ablauf dieser
              Frist werden die Bank und ihre Verknüpfungen endgültig gelöscht.
            </Dialog.Body>

            <Dialog.Footer gap={3} mt={-4}>
              <Button variant="outline" size="md" onClick={() => onOpenChange(false)}>
                Abbrechen
              </Button>

              <Button
                size="md"
                bg="red.solid"
                _hover={{ opacity: 0.85 }}
                loading={loading}
                onClick={handleDelete}
              >
                Bank löschen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
